export enum StudentEnrollmentType {
    Enrollment,
    Assignation,
    Nomination
}